module.exports = __webpack_public_path__ + "img/box22.1d06fcb3.png";